import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import CustomizedTable from "../../../../CustomizedTable/CustomizedTable";
import { DefaultCell } from "../../../../CustomizedTable/CustomCells/CustomCells";
import CurrencyCell from "../../../../CustomizedTable/CustomCells/CurrencyCell/CurrencyCell";
import DateTimeRangeCell from "../../../../CustomizedTable/CustomCells/DateTimeRangeCell/DateTimeRangeCell";
import OfferCommentCell from "../../../../CustomizedTable/CustomCells/OfferCommentCell/OfferCommentCell";
import CarrierNameCell from "../../../../CustomizedTable/CustomCells/CarrierNameCell/CarrierNameCell";
import NumberRangeFilter from "../../../../CustomizedTable/Filters/NumberRangeFilter/NumberRangeFilter";
import DateRangeFilter from "../../../../CustomizedTable/Filters/DateRangeFilter/DateRangeFilter";

export default function CarrierOffersModalOffers({
  offers,
  handleTableAction
}) {
  const columns = useMemo(
    () => [
      {
        Header: "Offer",
        accessor: "amount",
        Filter: NumberRangeFilter,
        filter: "between",
        width: 90,
        Cell: CurrencyCell,
      },
      {
        Header: "Counter",
        accessor: "counterOffer",
        Filter: NumberRangeFilter,
        filter: "between",
        width: 90,
        Cell: CurrencyCell,
      },
      {
        Header: "Rep",
        accessor: "enteredUserId",
        filter: "fuzzyText",
        width: 100,
        Cell: DefaultCell,
      },
      {
        Header: "Carrier",
        accessor: "carrierName",
        idKey: "carrierId",
        filter: "fuzzyText",
        width: 240,
        Cell: CarrierNameCell,
      },
      {
        Header: "",
        id: "comments",
        width: 40,
        Cell: OfferCommentCell,
      },
      {
        Header: "Last Updated",
        accessor: "lastUpdatedDate",
        Filter: DateRangeFilter,
        filter: "dateBetween",
        width: 130,
        Cell: DateTimeRangeCell,
      },
    ]
  );

  return (
    offers.length > 0 &&
    <Box sx={{ marginBottom: "20px" }}>
      <span style={{ display: "flex", alignItems: "center" }}>
        <Typography variant="h3" color="primary.60">
          Recent Offers
        </Typography>
      </span>
      <Box sx={{ maxHeight: "200px", overflow: "auto" }}>
        <CustomizedTable
          id="current-offers"
          columns={columns}
          data={offers}
          defaultHeight={offers.length * 32}
          defaultWidth={700}
          actionCallback={handleTableAction}
        />
      </Box>
    </Box>
  );
}

CarrierOffersModalOffers.propTypes = {
  offers: PropTypes.array,
  handleTableAction: PropTypes.func
};